import { render, staticRenderFns } from "./CiAccommodationList.vue?vue&type=template&id=8d2062a0&"
import script from "./CiAccommodationList.vue?vue&type=script&lang=js&"
export * from "./CiAccommodationList.vue?vue&type=script&lang=js&"
import style0 from "./CiAccommodationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CiAccommodationList.vue"
export default component.exports